import React from 'react';
import Icon from 'components/AppIcon';

const DeleteConfirmationModal = ({ isArabic, clientName, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 animate-scale-in">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
              <Icon name="AlertTriangle" size={24} color="#dc2626" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {isArabic ? 'تأكيد الحذف' : 'Confirm Deletion'}
              </h3>
              <p className="text-sm text-gray-500">
                {isArabic ? 'هذا الإجراء لا يمكن التراجع عنه' : 'This action cannot be undone'}
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-gray-700">
              {isArabic 
                ? `هل أنت متأكد من أنك تريد حذف العميل "${clientName}"؟ سيتم حذف جميع البيانات المرتبطة بهذا العميل نهائياً.`
                : `Are you sure you want to delete client "${clientName}"? All associated data will be permanently removed.`
              }
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onConfirm}
              className="flex-1 inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors duration-200"
            >
              <Icon name="Trash2" size={16} className="mr-2" />
              {isArabic ? 'نعم، احذف' : 'Yes, Delete'}
            </button>
            <button
              onClick={onCancel}
              className="flex-1 inline-flex items-center justify-center px-4 py-2 bg-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
            >
              <Icon name="X" size={16} className="mr-2" />
              {isArabic ? 'إلغاء' : 'Cancel'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;